<template>
	<div class="wrapBox">
		<navheader current="3"></navheader>
		<div class="bannerBox">
			<div class="bannerCtx">
				<img  src="../assets/images/tj/banner.png" class="imgsize" />
				<div class="text">体检介绍</div>
			</div>
		</div>
		<div class="contentbox">
			<div class="contentItem">
				<img  src="../assets/images/tj/image1.png" class="contImg" />
				<div class="textbox">
					<div class="title">资深的体检医生团队</div>
					<div class="textctx ctx">
						疗养院拥有一支依托华东疗养院技术骨干为主体的专业团队，他们是国内疗休养保健医疗服务的"王牌战队"，将为您提供全方位的体检保健、医疗护理和健康指导。

					</div>
				</div>
			</div>
			<div class="commonStyle">
				<div class="contentItem" >
					<div class="textbox">
						<div class="title">先进的医疗仪器设备</div>
						<div class="textctx ctx">
							装备有3.0T核磁共振成像系统、320排超高端CT、DR、数字钼靶机、双能X线骨密度仪、高压氧舱、奥林巴斯消化内镜、胶囊胃镜、西门子全自动生化免疫流水线、超声诊断系统、动脉硬化仪、肺功能检查仪、理疗、体疗、音疗等大批先进医疗仪器设备。
						</div>
					</div>
					<img  src="../assets/images/tj/image2.png"  class="contImg"/>
				</div>
			</div>
			<div class="smallStyle">
				<div class="contentItem" >
					<img  src="../assets/images/tj/image2.png"  class="contImg"/>
					<div class="textbox">
						<div class="title">先进的医疗仪器设备</div>
						<div class="textctx ctx">
							装备有3.0T核磁共振成像系统、320排超高端CT、DR、数字钼靶机、双能X线骨密度仪、高压氧舱、奥林巴斯消化内镜、胶囊胃镜、西门子全自动生化免疫流水线、超声诊断系统、动脉硬化仪、肺功能检查仪、理疗、体疗、音疗等大批先进医疗仪器设备。
						</div>
					</div>
				</div>
			</div>
			<div class="contentItem">
				<img  src="../assets/images/tj/image3.png"  class="contImg"/>
				<div class="textbox">
					<div class="title">全面丰富的定制化服务</div>
					<div class="textctx ctx">
						检前由首席总检医师根据客人基本信息、健康状况、工作环境、饮食习惯、睡眠习惯、运动习惯及现有健康档案来规划体检内容，检后为其体检结果作深入分析，为您定制个性化健康方案和疾病预防的专业建议，并接受预约上门为企业进行健康宣教。
					</div>
				</div>
			</div>
		</div>
		<footercommon></footercommon>
	</div>
</template>

<script>
	import navheader from "../components/navheader.vue";
	import footercommon from "../components/footercommon.vue";
	export default{
		components: { navheader,footercommon},
		props:['current'],
		data(){
			return{
				
			}
		}
	}
</script>

<style lang="scss" scoped> 
.imgsize{
	width: 63.9375rem;
	height: 22.9375rem;
}
.contentbox{
		min-width: $commoneWidth;
		margin: 0 auto;
		margin: 9.375rem;
		.contentItem{
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 10.625rem;
			.contImg{
				width: 31.875rem;
				height: 20.25rem;
			}
			.textbox{
				width: calc(100% - 35rem);
				.title{
					color:$baseColor;
					font-size: 2.625rem;
					font-weight: 800;
				}
				.ctx{
					margin-top: 2.3125rem;
					line-height: 2rem;
				}
			}
		}
	}
	@media screen and (max-width: 768px) {//手机版本
		.imgsize{
			width: 100%;
			height: 127px;
		}
		.contentbox{
			min-width: auto;
			max-width: 768px;
			margin: 10px auto;
			.contentItem{
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 10px;
				flex-direction: column;
				.contImg{
					width: 90%;
					height:154px;
				}
				.textbox{
					width: 90%;
					.title{
						margin-top: 10px;
						font-size: 16px;
					}
					.ctx{
						margin-top: 5px;
						line-height: 20px;
					}
				}
			}
		}
	}
</style>